/**
* IconModel defines model for icons used in Hamburger Navigation
*
* @typedef IconModel
* @type {Object}
* @property {presetImage} PresetImage of the Icon
* @property {cmsImage} CmsImage of the Icon
*/

export class IconModel {
    presetImage: string;
    cmsImage?: number;

    constructor(presetImage: string, cmsImage?: number) {
        this.presetImage = presetImage;
        cmsImage && (this.cmsImage = cmsImage);
    }
}